import React, { useMemo } from 'react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

export interface IMonthSaleInfoProps {
  showHot?: 0 | 1;
  showMonthSales?: 0 | 1;
  statSaleCnt: number;
  statAvatar: string[];
}

const MonthSaleInfo: React.FC<IMonthSaleInfoProps> = (props) => {
  const { showHot, showMonthSales, statSaleCnt, statAvatar } = props

  const showAvatars = useMemo(() => {
    return statAvatar?.filter(item => !!item)?.slice(0, 5)
  }, [statAvatar])

  if ((!showHot && !showMonthSales) || (!statSaleCnt && (!statAvatar?.length || !showHot))) {
    return null
  }

  return (
    <div
      className={classNames('month-sales-info-wrapper', {
        'hot-wrapper': showMonthSales,
      })}
    >
      {!!(showMonthSales && statSaleCnt) && <span className='month-sales'>{i18n.t('menu.monthSaleCnt', { cnt: statSaleCnt })}</span>}
      {!!(showHot && showAvatars?.length) && (
        <div className='hot-avatars'>
          {showAvatars.map((item, index) => (
            <img src={item} key={index} />
          ))}
        </div>
      )}
    </div>
  )
}

export default MonthSaleInfo
